<template>
  <v-card class="mx-auto" width="256" tile color="#313942">
    <v-img width="120" aspect-ratio="1.25" contain class="mx-auto mt-10" src="@/assets/logo/menu-logo.png"></v-img>
    <p class="text-center white--text mt-4 mb-2">관리자 페이지</p>
    <v-divider color="grey" class="mx-16"></v-divider>

    <p v-if="$store.state.lafia_admin.is_logined" class="white--text text-center mt-4 mb-0" style="line-height: 20px">
      {{ $store.state.lafia_admin.name }}<br />
      <span style="font-size: 12px">{{ $store.state.lafia_admin.type }} 접속중</span>
    </p>

    <div class="d-flex justify-center mt-2 mb-17px">
      <v-btn v-if="$store.state.lafia_admin.is_logined" color="grey lighten-1" x-small width="20" height="20" fab depressed class="mr-2">
        <v-icon size="12">mdi-cog-outline</v-icon>
      </v-btn>
      <v-btn v-if="$store.state.lafia_admin.is_logined" color="grey lighten-1" x-small width="20" height="20" fab depressed to="/admin/auth/logout">
        <v-icon size="12">mdi-logout</v-icon>
      </v-btn>
    </div>

    <!-- 메뉴 그룹 -->
    <v-list v-if="$store.state.lafia_admin.is_logined" nav dense color="#313942">
      <!-- 메뉴 -->
      <v-list-item v-for="(item, index) in menu.general" :key="index" :to="item.link" class="py-1 px-3" :class="$route.path == item.link ? 'primary' : ''">
        <!-- 아이콘 -->
        <v-list-item-icon>
          <v-icon color="white">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <!-- 제목 -->
        <v-list-item-content>
          <v-list-item-title class="white--text">{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="grey darken-1 mx-2 my-4"></v-divider>

    <!-- 관리자 전용 메뉴 그룹 -->
    <v-list v-if="$store.state.lafia_admin.is_logined && $store.state.lafia_admin.type == '관리자'" nav dense color="#313942">
      <!-- 메뉴 -->
      <v-list-item v-for="(item, index) in menu.admin" :key="index" :to="item.link" class="py-1 px-3" :class="$route.path == item.link ? 'primary' : ''">
        <!-- 아이콘 -->
        <v-list-item-icon>
          <v-icon color="white">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <!-- 제목 -->
        <v-list-item-content>
          <v-list-item-title class="white--text">{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item href="https://admin.sela-castle.com/" target="_blank">
        <v-list-item-icon>
          <v-icon color="white">mdi-open-in-new</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">관리자 사진 보정 메뉴</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    menu: {
      general: [
        {
          text: "드레스 예약 스케줄",
          icon: "mdi-clock-time-five-outline",
          link: "/admin/lafia_castle",
        },
        {
          text: "드레스 운영 관리",
          icon: "mdi-touch-text-outline",
          link: "/admin/castle/onsite",
        },
        {
          text: "현장 결제 관리",
          icon: "mdi-account-credit-card-outline",
          link: "/admin/offile-pay",
        },
        {
          text: "회원 관리",
          icon: "mdi-account-box-outline",
          link: "/admin/user",
        },
        {
          text: "리뷰 관리",
          icon: "mdi-post",
          link: "/admin/review",
        },

        {
          text: "결제내역 관리",
          icon: "mdi-gift-outline",
          link: "/admin/payments",
        },
        {
          text: "해외 결제내역 관리",
          icon: "mdi-cash-marker",
          link: "/admin/payletter",
        },
        {
          text: "프로모션 관리",
          icon: "mdi-credit-card",
          link: "/admin/promotion",
        },
        {
          text: "이벤트 페이지 관리",
          icon: "mdi-sticker-emoji",
          link: "/admin/event",
        },
        {
          text: "트래블러 관리",
          icon: "mdi-wallet-travel",
          link: "/admin/travelers",
        },
        {
          text: "알림 내역",
          icon: "mdi-bell-badge-outline",
          link: "/admin/notifications",
        },
        {
          text: "쿠폰 관리",
          icon: "mdi-gift-outline",
          link: "/admin/coupons",
        },
        {
          text: "발행된 쿠폰 관리",
          icon: "mdi-gift-open-outline",
          link: "/admin/registeredCoupons",
        },
        {
          text: "인쇄 요청 목록",
          icon: "mdi-printer-outline",
          link: "/admin/picPrint",
        },
        // {
        //   text: "얼리버드 상품",
        //   icon: "mdi-ticket-confirmation-outline",
        //   link: "/admin/early",
        // },
        // {
        //   text: "솔로프리미엄 스케줄",
        //   icon: "mdi-clock-star-four-points-outline",
        //   link: "/admin/solo_premium",
        // },

        // {
        //   text: "스토어 관리",
        //   icon: "mdi-image-frame",
        //   link: "/admin/store",
        // },
      ],

      admin: [
        {
          text: "컨셉 관리",
          icon: "mdi-camera-image",
          link: "/admin/concept",
        },
        {
          text: "컨셉부스 관리",
          icon: "mdi-castle",
          link: "/admin/sela-castle",
        },
        {
          text: "컨셉부스 운영 설정",
          icon: "mdi-window-shutter-cog",
          link: "/admin/conceptbooth/setting",
        },
        {
          text: "세라캐슬 매출 관리",
          icon: "mdi-chart-box-outline",
          link: "/admin/stats/sale",
        },
        {
          text: "프로모션 매출 관리",
          icon: "mdi-chart-box-outline",
          link: "/admin/stats/promotionSale",
        },
        {
          text: "통계 관리",
          icon: "mdi-chart-bar",
          link: "/admin/stats",
        },
        // {
        //   text: "통계 관리(구)",
        //   icon: "mdi-chart-bar",
        //   link: "/admin/stats/old",
        // },
        {
          text: "트래블러 미션 관리",
          icon: "mdi-text-long",
          link: "/admin/travelers/missions",
        },
        {
          text: "트래블러 미션 댓글 관리",
          icon: "mdi-comment-search-outline",
          link: "/admin/travelers/missions/comments",
        },
        {
          text: "매출 관리",
          icon: "mdi-chart-box-outline",
          link: "/admin/sale",
        },
        {
          text: "직원 관리",
          icon: "mdi-shield-lock-outline",
          link: "/admin/staff",
        },
        {
          text: "이용약관 관리",
          icon: "mdi-note-text-outline",
          link: "/admin/rule",
        },
        {
          text: "개인정보처리방침 관리",
          icon: "mdi-security",
          link: "/admin/privacy",
        },
        {
          text: "오시는 길 관리",
          icon: "mdi-map-marker",
          link: "/admin/location",
        },
        {
          text: "키오스크 이용약관 관리",
          icon: "mdi-note-text-outline",
          link: "/admin/kioskRule",
        },

        // {
        //   text: "HOME 관리",
        //   icon: "mdi-home",
        //   link: "/admin/home",
        // },

        // {
        //   text: "컨셉부스 QNA 관리",
        //   icon: "mdi-tooltip-question-outline",
        //   link: "/admin/qna",
        // },

        // {
        //   text: "컨셉 무인촬영설정 관리",
        //   icon: "mdi-camera-flip-outline",
        //   link: "/admin/concept_auto",
        // },

        // {
        //   text: "메이커 관리",
        //   icon: "mdi-clipboard-account-outline",
        //   link: "/admin/maker",
        // },
      ],
    },
  }),
}
</script>
